/**
 * Botón de altavoz — silencia / reactiva el audio (TTS) de Galia.
 * Cuando está silenciado, Galia solo responde por texto (se ahorra el TTS).
 * Hermano visual de InfoButton / SettingsButton / ContentsButton: reusa
 * .info-button para el estilo base.
 */

import './InfoButton.css'; // reusa .info-button para el estilo base
import './AudioToggleButton.css';

interface AudioToggleButtonProps {
  enabled: boolean;
  onClick: () => void;
  /** Modo profesor (aide-prof): etiquetas en francés. Por defecto español. */
  aideProf?: boolean;
}

export function AudioToggleButton({ enabled, onClick, aideProf = false }: AudioToggleButtonProps) {
  const label = aideProf
    ? (enabled ? 'Couper la voix de Galia' : 'Activer la voix de Galia')
    : (enabled ? 'Silenciar la voz de Galia' : 'Activar la voz de Galia');
  const title = aideProf
    ? (enabled ? 'Couper la voix de Galia (texte seul)' : 'Activer la voix de Galia')
    : (enabled ? 'Silenciar a Galia (solo texto)' : 'Activar la voz de Galia');
  return (
    <button
      type="button"
      className={`info-button audio-toggle-button ${enabled ? '' : 'is-muted'}`}
      onClick={onClick}
      aria-label={label}
      aria-pressed={!enabled}
      title={title}
    >
      {enabled ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
      )}
    </button>
  );
}
